import style from './style.module.css';

export type ActiceSteps = 'first' | 'second' | 'third' | 'forth' | 'fifth';

interface IScanStepsFlow {
    isScanSetupWizard: boolean;
    existingAssessmentSection?: boolean;
    motiviewStep?: boolean;
    active: ActiceSteps[];
}

/**
 * The step numbers below are the positions in the full flow, not in what is
 * drawn. Steps three and four each drop out in some flows, so callers always
 * count from the full list and the widths follow whatever is left.
 */
const ScanStepsFlow = (props: IScanStepsFlow) => {
    const {
        isScanSetupWizard,
        active,
        existingAssessmentSection,
        motiviewStep,
    } = props;

    const steps = [
        {
            position: 1,
            label: `${isScanSetupWizard ? 'Group' : 'Scan'} details`,
            isShown: true,
        },
        { position: 2, label: 'Scan setup', isShown: true },
        {
            position: 3,
            label: 'Customize scan',
            isShown: !existingAssessmentSection,
        },
        { position: 4, label: 'Motiview setup', isShown: !!motiviewStep },
        { position: 5, label: 'Review', isShown: true },
    ].filter((step) => step.isShown);

    const current = active.length;
    const width = `${100 / steps.length}%`;

    return (
        <ul className={style.steps}>
            {steps.map((step) => (
                <li
                    key={step.position}
                    className={
                        step.position === current
                            ? style.active
                            : step.position < current
                            ? style.steps__exist
                            : ''
                    }
                    style={{ width }}>
                    {step.label}
                </li>
            ))}
        </ul>
    );
};

export default ScanStepsFlow;
